import React from "react";
import { IconProps } from "./IconProps";

const ArrowRight: React.FC<IconProps> = ({
    size = 20,
    color = "#F7F9F9",
    ...props
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 21 21"
            fill="none"
            {...props}
        >
            <path
                d="M5.13211 10.9727L16.7988 10.9503M16.7988 10.9503L10.9542 5.12817M16.7988 10.9503L10.9767 16.7948"
                stroke={color}
                strokeWidth="1.67"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default ArrowRight;
